/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {MDXWrapper} from 'lib/mdx';
import Image from 'next/image';
import ImageTabs from 'components/image-tabs';
import LanguageLinks from 'components/language-links';
import openAddOn from '../../public/how-to/1-open-addon.png';
import allowAccess from '../../public/how-to/2-allow-access.png';
import uploadFile from '../../public/how-to/3-upload-file.png';
import selectLanguage from '../../public/how-to/4-select-language.png';
import preview from '../../public/how-to/5-preview.png';
import purchase from '../../public/how-to/6-purchase.png';
import buyNow from '../../public/how-to/7-buy-now.png';
import afterPurchase from '../../public/how-to/8-after-purchase.png';
import transcribing from '../../public/how-to/9-transcribing.png';
import showTranscript from '../../public/how-to/10-show-transcript.png';
import suggestedFile from '../../public/how-to/suggested-file.png';
import lastEdit from '../../public/how-to/last-edit.png';
export const metadata = {
  title: 'Cómo transcribir un audio',
  description: 'Descubra, paso a paso, cómo transcribir todos sus archivos de audio o video usando el complemento TranscribeKit para Google Drive.',
  language: 'es',
  availableLanguages: ['en', 'es', 'fr']
};
const MDXLayout = function Layout({children}) {
  return _jsx(MDXWrapper, {
    metadata: metadata,
    children: children
  });
};
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      em: "em",
      h2: "h2",
      a: "a",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "¿Cómo transcribir archivos de audio o video a texto?"
      }), "\n", _jsx(LanguageLinks, {
        current: metadata.language,
        available: metadata.availableLanguages
      }), "\n", _jsxs(_components.p, {
        children: ["La transcripción automática speech-to-text utiliza inteligencia artificial para convertir una grabación de audio en texto. Sigue los siguientes pasos para transcribir cualquier archivo o video a texto usando el complemento ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " para ", _jsx(_components.em, {
          children: "Google Drive"
        }), "."]
      }), "\n", _jsxs(_components.h2, {
        children: ["1. Instale el complemento en ", _jsx(_components.em, {
          children: "Google Drive"
        })]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.em, {
          children: "TranscribeKit"
        }), " funciona como un complemento de ", _jsx(_components.em, {
          children: "Google Drive"
        }), ". Puede instalarlo haciendo clic\n", _jsx(_components.a, {
          href: "https://workspace.google.com/marketplace/app/transcribekit/831507088910",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "aquí"
        }), " para acceder a la ", _jsx(_components.em, {
          children: "Google Marketplace"
        }), ", luego haga clic en el botón ", _jsx(_components.strong, {
          children: "Install"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Una vez que el complemento está instalado, vaya a su ", _jsx(_components.a, {
          href: "https://drive.google.com",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "Google Drive"
        }), " y haga clic en el icono ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " que aparece en la columna de derecha."]
      }), "\n", _jsx("div", {
        className: "flex border lg:-mx-24",
        children: _jsx(Image, {
          src: openAddOn,
          alt: "Abrir el complemento",
          quality: 100,
          placeholder: "blur",
          priority: true
        })
      }), "\n", _jsx(_components.h2, {
        children: "2. Suba su archivo de audio o video"
      }), "\n", _jsxs(_components.p, {
        children: ["Una vez que se abra el complemento, seleccione tu archivo de audio o video en ", _jsx(_components.em, {
          children: "Google Drive"
        }), ". No haga doble clic en el archivo porque esto iniciará el audio. El complemento detectará el archivo seleccionado y el botón ", _jsx(_components.strong, {
          children: "Allow access"
        }), " aparecerá. Haga clic en eso para permitir que ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " acceda al archivo. Aparecerá un botón ", _jsx(_components.strong, {
          children: "Upload File"
        }), ". Haga clic en eso para enviar el archivo al servidor de transcripción. Espere un poco, luego haga clic en el botón ", _jsx(_components.strong, {
          children: "Refresh"
        }), ". Entonces debería aparecer la siguiente pantalla."]
      }), "\n", _jsxs(_components.p, {
        children: ["⚠ ", _jsxs(_components.em, {
          children: ["No haga clic en los archivos en la sección ", _jsx(_components.strong, {
            children: "Sugerida"
          }), " en la parte superior, no funcionará. Para estos archivos, haga clic-", _jsx(_components.strong, {
            children: "derecho"
          }), " y luego haga clic en ", _jsx(_components.strong, {
            children: "Mostrar ubicación del archivo"
          })]
        })]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: suggestedFile,
            caption: 'Archivos sugeridos'
          }, {
            image: allowAccess,
            caption: 'Permitir el acceso'
          }, {
            image: uploadFile,
            caption: 'Subir el archivo'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "3. Selecciona el idioma del audio"
      }), "\n", _jsxs(_components.p, {
        children: ["Una vez que se cargue su archivo, aparecerá la pantalla ", _jsx(_components.strong, {
          children: "New Transcript"
        }), ". El ", _jsx(_components.strong, {
          children: "idioma de audio"
        }), " preseleccionado es ", _jsx(_components.em, {
          children: "English (United States)"
        }), ". Si el idioma que se habla en su grabación no es el inglés, seleccione el idioma correcto de la lista."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: selectLanguage,
            alt: "Seleccionar idioma de audio",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "4. Solicite una vista previa de los primeros segundos"
      }), "\n", _jsxs(_components.p, {
        children: ["Después de seleccionar el idioma de su elección, haga clic en el botón ", _jsx(_components.strong, {
          children: "Click Here to Preview"
        }), ". Luego se transcribirán los primeros 15 segundos de su archivo de audio o video."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.em, {
          children: "Si no aparece la vista previa, puede ser porque el inicio de tu grabación no contiene ningún sonido. El complemento intentará ignorar el silencio, pero no funcionará si el audio contiene ruido de fondo. Aún podrá transcribir el archivo, pero primero asegúrese de haber seleccionado el idioma correcto."
        })
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: preview,
            alt: "Obtener una vista previa de la transcripción",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "5. Compre tiempo de transcripción"
      }), "\n", _jsxs(_components.p, {
        children: ["Si su saldo de tiempo de transcripción es demasiado bajo, verá el siguiente mensaje: ", _jsxs(_components.strong, {
          children: ["\"Click HERE to purchase more transcription time at ", _jsx(_components.em, {
            children: "TranscribeKit.com"
          }), "\""]
        }), ". Haga clic en este enlace para acceder a su cuenta en ", _jsx(_components.em, {
          children: "TranscribeKit.com"
        }), " desde una nueva pestaña."]
      }), "\n", _jsxs(_components.p, {
        children: ["Ahora que está en la página ", _jsx(_components.em, {
          children: "Account"
        }), ", haga clic en uno de los botones ", _jsx(_components.strong, {
          children: "Buy Now"
        }), " para comprar 1, 5 o 10 horas de tiempo de transcripción. Puede pagar con tarjeta de crédito o desde su cuenta ", _jsx(_components.em, {
          children: "PayPal"
        }), ". Los pagos son procesados por ", _jsx(_components.em, {
          children: "Paddle"
        }), " y recibirá una factura por correo electrónico."]
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["Si desea comprar dos horas, por ejemplo, haga clic en el botón ", _jsx(_components.strong, {
            children: "Buy Now"
          }), " para 1 hora y luego seleccione la cantidad deseada en la sección superior izquierda de la pantalla de pago."]
        })
      }), "\n", _jsx(_components.p, {
        children: "Una vez que el pago este finalizado, la transcripción debería aparecer automáticamente en su cuenta (esto puede tardar unos segundos)."
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: purchase,
            caption: 'Saldo demasiado bajo'
          }, {
            image: buyNow,
            caption: 'Página de la cuenta'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "6. Solicite la transcripción completa"
      }), "\n", _jsxs(_components.p, {
        children: ["Ahora que tiene suficiente tiempo de transcripción, vuelva a ", _jsx(_components.em, {
          children: "Google Drive"
        }), " y haga clic en el botón ", _jsx(_components.strong, {
          children: "Refresh"
        }), " para actualizar su saldo. Luego, haga clic en ", _jsx(_components.strong, {
          children: "Click Here to Transcribe"
        }), ". Su solicitud se enviará al servidor de transcripción."]
      }), "\n", _jsxs(_components.p, {
        children: ["⚠ ", _jsx(_components.em, {
          children: "El tiempo de transcripción se restará de su saldo. Por lo tanto, compruebe que ha seleccionado el correcto idioma de grabación."
        })]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: afterPurchase,
            alt: "Nueva transcripción",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "7. Espere el correo electrónico que contiene su transcripción"
      }), "\n", _jsx(_components.p, {
        children: "Aparecerá luego una pantalla para informarle que su archivo se está transcribiendo. Este proceso debería tomar menos de una hora. Después, recibirá un correo electrónico cuando se complete la transcripción. El tiempo necesario para completar la transcripción puede variar según la duración del archivo y la ocupación del servidor. Por tanto, puede suceder que la transcripción tarde un poco más."
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: transcribing,
            alt: "Transcripción procesando",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "8. Si es necesario, realice correcciones manuales"
      }), "\n", _jsxs(_components.p, {
        children: ["Luego, haga clic en el botón ", _jsx(_components.strong, {
          children: "Open In Google Docs"
        }), " en el correo electrónico que recibió. Esto lo redireccionará a un archivo ", _jsx(_components.em, {
          children: "Google Doc"
        }), " que contiene su transcripción completa. También puede acceder a esto desde el complemento, haciendo clic en el botón ", _jsx(_components.strong, {
          children: "Open Full Transcript"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["No dude en hacer correcciones manuales a este documento si se ve necesario. Si luego desea consultar la versión original, simplemente haga clic en el enlace ", _jsx(_components.strong, {
            children: "Última modificación"
          }), " junto al menú en la parte superior del documento para ver el historial de versiones."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Si transcribió accidentalmente en el idioma incorrecto, haga clic en el botón ", _jsx(_components.strong, {
          children: "Transcribe Again"
        }), " para volver a intentarlo. Sin embargo, tenga en cuenta que esta acción volverá a deducir el tiempo de transcripción de su saldo."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: showTranscript,
            caption: 'Ver la transcripción'
          }, {
            image: lastEdit,
            caption: 'Enlace última modificación'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "Artículos relacionados"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe-zoom",
          children: "Cómo transcribir una grabación de reunión con Zoom"
        })
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe-google-meet",
          children: "Cómo transcribir una grabación de Google Meet"
        })
      })]
    });
  }
}
export default MDXContent;
